import { AuthApi } from '../../../api';
import { ToastStateHandler } from '../../../api/utils/ToastStateHandler';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

interface ConfirmForgotPasswordValues {
    confirmationCode: string;
    username: string;
    password: string;
}

const useHttpPostResetPassword = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (confirmForgotPassword: ConfirmForgotPasswordValues) => {
        const { username, confirmationCode, password } = confirmForgotPassword;
        const { exec, clearCache, abort } = authApi.confirmForgotPassword({
            body: {
                username,
                confirmationCode,
                password,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.passwordChangeTitle'), t('auth.passwordChangeMessage_Success'));
                clearCache();
            },
            onError: () => {
                toastHandler.push('error', t('auth.passwordChangeTitle'), t('auth.passwordChangeMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostResetPassword;
